import { render, staticRenderFns } from "./siloPicker.vue?vue&type=template&id=40bc52ac&scoped=true&"
import script from "./siloPicker.vue?vue&type=script&lang=js&"
export * from "./siloPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bc52ac",
  null
  
)

export default component.exports